var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1668 15.8333H66.5002C60.529 15.8333 57.5435 15.8333 55.6885 17.6882C53.8335 19.5433 53.8335 22.5288 53.8335 28.4999V41.1666C53.8335 47.1377 53.8335 50.1232 55.6885 51.9782C57.5435 53.8333 60.529 53.8333 66.5002 53.8333H79.1668C85.1379 53.8333 88.1234 53.8333 89.9785 51.9782C91.8335 50.1232 91.8335 47.1377 91.8335 41.1666V28.4999C91.8335 22.5288 91.8335 19.5433 89.9785 17.6882C88.1234 15.8333 85.1379 15.8333 79.1668 15.8333Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1668 15.8333H66.5002C60.529 15.8333 57.5435 15.8333 55.6885 17.6882C53.8335 19.5433 53.8335 22.5288 53.8335 28.4999V41.1666C53.8335 47.1377 53.8335 50.1232 55.6885 51.9782C57.5435 53.8333 60.529 53.8333 66.5002 53.8333H79.1668C85.1379 53.8333 88.1234 53.8333 89.9785 51.9782C91.8335 50.1232 91.8335 47.1377 91.8335 41.1666V28.4999C91.8335 22.5288 91.8335 19.5433 89.9785 17.6882C88.1234 15.8333 85.1379 15.8333 79.1668 15.8333Z",
    stroke: "url(#paint0_linear_16725_956)",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3335 57H63.3335V139.333H82.3335V57Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3335 57H63.3335V139.333H82.3335V57Z",
    stroke: "url(#paint1_linear_16725_956)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 136.167H98.1667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 136.167H98.1667",
    stroke: "url(#paint2_linear_16725_956)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95 25.3333H120.333C130.827 25.3333 139.333 31.5199 139.333 39.1514V50.6666H120.333V39.1514H95V25.3333Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95 25.3333H120.333C130.827 25.3333 139.333 31.5199 139.333 39.1514V50.6666H120.333V39.1514H95V25.3333Z",
    stroke: "url(#paint3_linear_16725_956)",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.094 77.4016L120.094 77.4016L120.094 77.4016ZM120.094 77.4016L120.088 77.4082M120.094 77.4016L120.077 77.3781L120.094 77.4016ZM117.439 80.3814C117.464 80.4049 117.5 80.4381 117.546 80.4815L117.578 78.1858L117.579 78.1859L117.579 78.186L117.579 78.1861L117.579 78.1861L117.579 78.1863L117.582 78.1881L117.603 78.2039L117.775 78.33L118.579 78.9204L117.674 79.9065L117.673 79.9068L117.332 80.2789C117.372 80.3197 117.406 80.3513 117.411 80.356L117.412 80.3564C117.417 80.3612 117.422 80.3656 117.426 80.3693L117.427 80.37L117.431 80.3741L117.439 80.3814Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.094 77.4016L120.094 77.4016L120.094 77.4016ZM120.094 77.4016L120.088 77.4082M120.094 77.4016L120.077 77.3781L120.094 77.4016ZM117.439 80.3814C117.464 80.4049 117.5 80.4381 117.546 80.4815L117.578 78.1858L117.579 78.1859L117.579 78.186L117.579 78.1861L117.579 78.1861L117.579 78.1863L117.582 78.1881L117.603 78.2039L117.775 78.33L118.579 78.9204L117.674 79.9065L117.673 79.9068L117.332 80.2789C117.372 80.3197 117.406 80.3513 117.411 80.356L117.412 80.3564C117.417 80.3612 117.422 80.3656 117.426 80.3693L117.427 80.37L117.431 80.3741L117.439 80.3814Z",
    stroke: "white",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.094 77.4016L120.094 77.4016L120.094 77.4016ZM120.094 77.4016L120.088 77.4082M120.094 77.4016L120.077 77.3781L120.094 77.4016ZM117.439 80.3814C117.464 80.4049 117.5 80.4381 117.546 80.4815L117.578 78.1858L117.579 78.1859L117.579 78.186L117.579 78.1861L117.579 78.1861L117.579 78.1863L117.582 78.1881L117.603 78.2039L117.775 78.33L118.579 78.9204L117.674 79.9065L117.673 79.9068L117.332 80.2789C117.372 80.3197 117.406 80.3513 117.411 80.356L117.412 80.3564C117.417 80.3612 117.422 80.3656 117.426 80.3693L117.427 80.37L117.431 80.3741L117.439 80.3814Z",
    stroke: "url(#paint4_linear_16725_956)",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.815 95.1682C122.701 95.3707 122.651 95.5412 122.642 95.572C122.641 95.5735 122.641 95.5747 122.641 95.5755C122.605 95.6954 122.588 95.7948 122.585 95.8112C122.585 95.812 122.585 95.8125 122.585 95.8129C122.579 95.8453 122.576 95.8708 122.574 95.8821C122.572 95.9006 122.569 95.9259 122.567 95.9401C122.567 95.9387 122.567 95.9371 122.568 95.9353C122.57 95.9151 122.573 95.887 122.578 95.8529C122.588 95.7867 122.601 95.7158 122.618 95.6403C122.653 95.4904 122.705 95.3281 122.775 95.1515L122.815 95.1682ZM122.815 95.1682L124.556 95.8645L124.632 95.895C124.565 96.061 124.557 96.1411 124.556 96.151C124.556 96.1512 124.556 96.1514 124.556 96.1516C124.556 96.1522 124.556 96.1522 124.556 96.1516L122.815 95.1682Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.815 95.1682C122.701 95.3707 122.651 95.5412 122.642 95.572C122.641 95.5735 122.641 95.5747 122.641 95.5755C122.605 95.6954 122.588 95.7948 122.585 95.8112C122.585 95.812 122.585 95.8125 122.585 95.8129C122.579 95.8453 122.576 95.8708 122.574 95.8821C122.572 95.9006 122.569 95.9259 122.567 95.9401C122.567 95.9387 122.567 95.9371 122.568 95.9353C122.57 95.9151 122.573 95.887 122.578 95.8529C122.588 95.7867 122.601 95.7158 122.618 95.6403C122.653 95.4904 122.705 95.3281 122.775 95.1515L122.815 95.1682ZM122.815 95.1682L124.556 95.8645L124.632 95.895C124.565 96.061 124.557 96.1411 124.556 96.151C124.556 96.1512 124.556 96.1514 124.556 96.1516C124.556 96.1522 124.556 96.1522 124.556 96.1516L122.815 95.1682Z",
    stroke: "white",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.815 95.1682C122.701 95.3707 122.651 95.5412 122.642 95.572C122.641 95.5735 122.641 95.5747 122.641 95.5755C122.605 95.6954 122.588 95.7948 122.585 95.8112C122.585 95.812 122.585 95.8125 122.585 95.8129C122.579 95.8453 122.576 95.8708 122.574 95.8821C122.572 95.9006 122.569 95.9259 122.567 95.9401C122.567 95.9387 122.567 95.9371 122.568 95.9353C122.57 95.9151 122.573 95.887 122.578 95.8529C122.588 95.7867 122.601 95.7158 122.618 95.6403C122.653 95.4904 122.705 95.3281 122.775 95.1515L122.815 95.1682ZM122.815 95.1682L124.556 95.8645L124.632 95.895C124.565 96.061 124.557 96.1411 124.556 96.151C124.556 96.1512 124.556 96.1514 124.556 96.1516C124.556 96.1522 124.556 96.1522 124.556 96.1516L122.815 95.1682Z",
    stroke: "url(#paint5_linear_16725_956)",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.761 77.4016L132.761 77.4016L132.761 77.4016ZM132.761 77.4016L132.755 77.4082M132.761 77.4016L132.744 77.3781L132.761 77.4016ZM130.106 80.3814C130.131 80.4049 130.167 80.4381 130.213 80.4815L130.245 78.1858L130.245 78.1859L130.245 78.186L130.245 78.1861L130.245 78.1861L130.246 78.1863L130.248 78.1881L130.27 78.2039L130.441 78.33L131.245 78.9204L130.34 79.9065L130.34 79.9068L129.998 80.2789C130.038 80.3197 130.073 80.3513 130.078 80.356L130.078 80.3564C130.084 80.3612 130.088 80.3656 130.093 80.3693L130.093 80.37L130.098 80.3741L130.106 80.3814Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.761 77.4016L132.761 77.4016L132.761 77.4016ZM132.761 77.4016L132.755 77.4082M132.761 77.4016L132.744 77.3781L132.761 77.4016ZM130.106 80.3814C130.131 80.4049 130.167 80.4381 130.213 80.4815L130.245 78.1858L130.245 78.1859L130.245 78.186L130.245 78.1861L130.245 78.1861L130.246 78.1863L130.248 78.1881L130.27 78.2039L130.441 78.33L131.245 78.9204L130.34 79.9065L130.34 79.9068L129.998 80.2789C130.038 80.3197 130.073 80.3513 130.078 80.356L130.078 80.3564C130.084 80.3612 130.088 80.3656 130.093 80.3693L130.093 80.37L130.098 80.3741L130.106 80.3814Z",
    stroke: "white",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.761 77.4016L132.761 77.4016L132.761 77.4016ZM132.761 77.4016L132.755 77.4082M132.761 77.4016L132.744 77.3781L132.761 77.4016ZM130.106 80.3814C130.131 80.4049 130.167 80.4381 130.213 80.4815L130.245 78.1858L130.245 78.1859L130.245 78.186L130.245 78.1861L130.245 78.1861L130.246 78.1863L130.248 78.1881L130.27 78.2039L130.441 78.33L131.245 78.9204L130.34 79.9065L130.34 79.9068L129.998 80.2789C130.038 80.3197 130.073 80.3513 130.078 80.356L130.078 80.3564C130.084 80.3612 130.088 80.3656 130.093 80.3693L130.093 80.37L130.098 80.3741L130.106 80.3814Z",
    stroke: "url(#paint6_linear_16725_956)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_956",
    x1: 53.8335,
    y1: 15.8333,
    x2: 98.9929,
    y2: 28.6944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_956",
    x1: 63.3335,
    y1: 57,
    x2: 87.6396,
    y2: 58.5974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_956",
    x1: 47.5,
    y1: 136.167,
    x2: 47.8111,
    y2: 140.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_956",
    x1: 95,
    y1: 25.3333,
    x2: 140.626,
    y2: 48.0728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16725_956",
    x1: 114,
    y1: 76,
    x2: 129.053,
    y2: 80.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16725_956",
    x1: 120.333,
    y1: 88.6667,
    x2: 135.387,
    y2: 92.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16725_956",
    x1: 126.667,
    y1: 76,
    x2: 141.72,
    y2: 80.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.b3eb06f7c34dd7d8e761e2f5ca1cdb99.svg";
export { ForwardRef as ReactComponent };